import { lazy } from 'react'
import { DollarSign } from 'lucide-react'
import type { FeatureRoute, NavItem } from '@/features/types'

const Revenue = lazy(() => import('./pages/Revenue').then((m) => ({ default: m.Revenue })))

// Revenue actuals are the firm's full client revenue book — leadership-only.
// Backend require_role is the load-bearing gate; this is defense-in-depth so the
// route + nav link aren't even reachable for non-admins.
const revenueViewers = ['admin']

export const revenueRoutes: FeatureRoute[] = [
  { path: 'revenue', element: <Revenue />, roles: revenueViewers },
]

export const revenueNav: NavItem[] = [
  { to: '/revenue', label: 'Revenue', icon: DollarSign, section: 'Sales', adminOnly: true },
]
